import { render, staticRenderFns } from "./OperaShopGoodsWindow.vue?vue&type=template&id=7bb45f38&scoped=true&"
import script from "./OperaShopGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaShopGoodsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaShopGoodsWindow.vue?vue&type=style&index=0&id=7bb45f38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb45f38",
  null
  
)

export default component.exports